import Instruction from "./Instruction";

/**
 * Ask the user to make a choice between some SelectOption, the response will be set in a variable by name.
 *
 * name and options can be resolve at runtime.
 */
class Select extends Instruction
{
	constructor(name, options, optionsCallback)
	{
		super();
		this.name = name;
		this.options = options;
		this.optionsCallback = optionsCallback;
	}
	resolve(variables)
	{
		if (this.optionsCallback)
		{
			this.options = this.optionsCallback(this.options, variables);
		}
		super.resolve(variables);
		this.name = Instruction._resolveValue(this.name, variables);
		this.options = Instruction._resolveValue(this.options, variables);

		this.options.forEach((option) => option.resolve(variables));

		this.options = this.options.filter((option) => option.condition);
	}
}

export default Select
